// ===================================================
// ФАЙЛ: frontend/src/pages/Error/InternalServerErrorPage.jsx
// ===================================================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import MonumentErrorLayout from '../../components/Error/MonumentErrorLayout';
import { SUPPORT_EMAIL } from '../../utils/externalLinks';

const InternalServerErrorPage = () => {
  const navigate = useNavigate();

  return (
    <MonumentErrorLayout
      status="500"
      title="Ошибка сервера"
      description="В мастерской что-то щёлкнуло не так. Мы уже чиним шестерёнки."
      bgImageName="500"
    >
      <div className="mb-err-page__actions-row">
        <button type="button" className="mb-err-page__cta" onClick={() => navigate('/')}>
          На главную
        </button>
        <a className="mb-err-page__cta mb-err-page__cta--secondary" href={`mailto:${SUPPORT_EMAIL}`}>
          Написать в поддержку
        </a>
      </div>
    </MonumentErrorLayout>
  );
};

export default InternalServerErrorPage;
